import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import { ExpandableList } from '@bibliocommons/expandable';
import DistinctionItem from './DistinctionItem';

import './Distinctions.scss';

function renderDistinctionList(title, items) {
  return (
    <div className="list">
      <h4>{title}</h4>
      <ExpandableList
        className="distinction-list"
        collapseCount={3}
        expandLinkHref="#show-more-distinctions"
        getItemKey={item => `${item.get('title')}-${item.get('subtitle')}}`}
        itemClassName="distinction-item"
        list={items}
        renderItem={item => <DistinctionItem item={item} />}
        stacked
      />
    </div>
  );
}

const distinctions = Immutable.fromJS({
  awards: [
    {
      title: 'The Reading List',
      subtitle: 'Winner, Science Fiction, 2012',
      url: '/explore/awards/524289'
    }
  ],
  bestsellers: [
    {
      title: 'New York Times',
      subtitle: 'Hardcover Fiction'
    }
  ]
});

export default class Distinctions extends React.PureComponent {
  render() {
    return (
      <div className="cp-bib-distinctions">
        <h3>
          <FormattedMessage id="awards_and_bestsellers" />
        </h3>

        <div className="lists">
          {renderDistinctionList(<FormattedMessage id="awards" />, distinctions.get('awards'))}

          {renderDistinctionList(<FormattedMessage id="bestsellers" />, distinctions.get('bestsellers'))}
        </div>
      </div>
    );
  }
}
